import { render, staticRenderFns } from "./leftnav.vue?vue&type=template&id=6435e238&"
import script from "./leftnav.vue?vue&type=script&lang=js&"
export * from "./leftnav.vue?vue&type=script&lang=js&"
import style0 from "./leftnav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports